import React, { useState, useCallback } from 'react'
import clear from '../../../assets/icons/clear.svg'
import warningOrg from '../../../assets/icons/warningOrg.svg'
import { Button } from 'syngenta-react-components'
import TableStatus from '../../../components/subComponents/TableStatus/TableStatus'
import Alert from '../../../components/subComponents/Notifications/Alert'
import { fieldLostplantingStewardship, patchStewardshipHistoryData } from '../../../services/apiHelper'

const FieldLostView = ({ showFieldLost, setShowFieldLost, plantingData, stewardship_activity_id, getStewardshipFieldsCall, replantOrLost, fieldCompleteOrNot, contract_id, userInfo }) => {
  const [checkedData, setCheckedData] = useState()
  const [showNextDetails, setShowNextDetails] = useState(false)
  const [lostDate, setLostDate] = useState(new Date().toISOString().substr(0, 10))
  const [notes, setNotes] = useState('')
  const [showAlert, setShowAlert] = useState(false)
  const [confirmStatus,setConfirmStatus] = useState(false)

  const patchStewardshipHistoryCall = useCallback(() => {
    const userInfoForStewardship = { ...userInfo, action:'Field lost' }
    patchStewardshipHistoryData(contract_id, userInfoForStewardship)
  }, [
    contract_id, userInfo
  ])

  const checkedFieldLostdata = id => {
    const findIsDisable = fieldCompleteOrNot.findIndex(data => data.id === id && data.isDisable === true)
    if(findIsDisable === -1) {
      const obj = plantingData.find(data => data.id === id)
      setShowAlert(false)
      setCheckedData(obj)
    } else {
      setShowAlert(true)
      setCheckedData()
      document.getElementById('lost' + id).checked = false
    }
  }

  const showFieldLostFunc = () => {
    setShowNextDetails(false)
    setShowFieldLost(prev => !prev)
  }

  const hideFieldLostFunc = () => {
    if (checkedData) {
      document.getElementById('lost' + checkedData.id).checked = false
      setCheckedData()
    }
    setNotes('')
    setLostDate(new Date().toISOString().substr(0, 10))
    setShowNextDetails(false)
    setShowFieldLost(false)
  }

  const showNextDetailsFunc = () => {
    setShowNextDetails(prev => !prev)
    setShowFieldLost(false)
  }


  const saveFieldLostData = () => {
    document.getElementById('lost' + checkedData.id).checked = false
    setCheckedData()
    setNotes('')
    setLostDate(new Date().toISOString().substr(0, 10))
    const params = {
      stewardship_id: stewardship_activity_id,
      field_id: checkedData.id,
      fieldLost_date: lostDate,
      acres_lost: checkedData.total_planted_acres.toString(),
      notes: notes
    }
    setConfirmStatus('LOADING')
    fieldLostplantingStewardship(params).then(res => {
      if (res.status === 200) {
        getStewardshipFieldsCall()
        patchStewardshipHistoryCall()
        setTimeout(()=> {
          setConfirmStatus()
          setShowNextDetails(false)
        },2000)
      }
    })
  }
  return (
    <>
      <div className="modalContainer" style={{ display: showFieldLost ? 'block' : 'none' }}>
        <div className="aHModalChild posr t100">
          <div className='w100% h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4'>
            <div className='df jcsb'>
              <p className='fz16 m5 fw600 tal'>Stewardship: Field Lost</p>
              <button className='bdnone mr5 bgc-t' onClick={hideFieldLostFunc}>
                <img src={clear} alt='cancel button' />
              </button>
            </div>
            <div className='bdnone bt1-s-lightgray' />
            <p className='fz16 m5 fw600 tal'>Select field for lost</p>
            <div className="df">
              <div className="mr25 w33.3333% pl10 ml5">
                <div className="bd1-s-lightgray pb15 pl5 bdrs-4 pr5 tal">
                  {
                    plantingData?.map((data, id) =>                                    
                      !replantOrLost?.[id]?.fieldLost ?
                        <div key={id} className="w150 mau mt10 tal">
                          <input className="dib w20" type="radio" id={'lost' + data.id} name="plantingData" value={data.name} onClick={() => {
                            checkedFieldLostdata(data.id)
                          }} />
                          <label htmlFor={'lost' + data.id}>{data.name}</label>
                        </div> : ''                                     
                    )
                  }
                </div>
              </div>

              <div className="w66.6666% pr10 mr5">
                <div className="table">
                  <div className="tableHeader pl16">
                    <div className="Name cell">
                      <div>Name</div>
                    </div>
                    <div className="Acres cell">
                      <div>Acres</div>
                    </div>
                  </div>
                  {
                    checkedData ?
                      <div role="row" className="pl16 df h48 ov dp aic">
                        <div className="name cell">{checkedData.name}</div>
                        <div className="total_planted_acres cell">{checkedData.total_planted_acres}</div>
                      </div>
                      : <p className="fz15">Select a field from the on the left</p>
                  }
                </div>
              </div>
            </div>
            <div className='mt20 mb16 bdnone bt1-s-lightgray' />
            <div className='df jcfe posr'>
              <Button type='default' text='Cancel' onClick={hideFieldLostFunc} />
              <Button type='success' text='Next: Field lost details' customClassName='mr15 ml10' onClick={showNextDetailsFunc} disabled={checkedData ? false : true}/>
            </div>
          </div>
        </div>
      </div>

      {showAlert ? (
        <Alert
          alertMessage='Please make sure to enter stewardship planting information first.'
          handleDismiss={() => setShowAlert(false)}
        />
      ) : null}

      <div className="modalContainer" style={{ display: showNextDetails ? 'block' : 'none' }}>
        <div className="aHModalChild posr t100">
          <div className='w100% h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4'>
            <div className='df jcsb'>
              <p className='fz16 m5 fw600 tal'>Stewardship: FieldLost</p>
              <button className='bdnone mr5 bgc-t' onClick={hideFieldLostFunc}>
                <img src={clear} alt='cancel button' />
              </button>
            </div>
            {confirmStatus === 'LOADING' ?
              <TableStatus status='LOADING'></TableStatus>
              :
              <>
                <div className='bdnone bt1-s-lightgray' />
                <p className='fz16 m5 mb15 fw600 tal'>Field lost details: {checkedData?.name}</p>
                <p className="bdrs-4 p10 fz15 ml15 mr15 tal pl40" style={{ border: '2px solid yellow', backgroundColor: 'lightyellow', position: 'relative' }}>
                  <img src={warningOrg} alt='' style={{ position: 'absolute', top: '10px', left: '12px' }} /> 
                You are about to mark this field as completely lost. This action cannot be undone. If you replanted this field with Enogen, please choose cancel and utilize the replant form
                </p>
                <div className="df fz15">
                  <div className="flx1 mr10">
                    <p className="m0 p0 pl15 tal">Date of field lost</p>
                    <input
                      role='grid'
                      aria-label='plantedDate'
                      className='bdrs-4 bd1-s-lightgray ml15 mt5 tal p9'
                      key='plant_date'
                      type='date'
                      value={lostDate}
                      onChange={e => {
                        setLostDate(e.target.value)
                      }}
                    />
                  </div>
                  <div className="flx1">
                    <p className="m0 p0 pl15 tal">Acres lost</p>
                    <p className="bdrs-4 bd1-s-lightgray mr0 ml15 mr15 mt5 tal">{checkedData?.total_planted_acres}</p>
                  </div>
                </div>
                <div className="fz15">
                  <p className="m0 pl15 tal">Notes (optional)</p>
                  <div className="ml15 mr15"><textarea rows="3" cols="70" className="w100%" value={notes} onChange={e => {
                    setNotes(e.target.value)
                  }} /></div>
                </div>
                <div className='mt20 mb16 bdnone bt1-s-lightgray' />
                <div className='df jcfe posr'>
                  <Button type='default' text='Back' onClick={showFieldLostFunc} />
                  <Button type='success' text='Save' customClassName='mr15 ml10' onClick={saveFieldLostData} />
                </div>
              </>
            }
          </div>
        </div>
      </div>
    </>
  )
}

export default FieldLostView